import { render, staticRenderFns } from "./Clinics.html?vue&type=template&id=2335ed75&external"
import script from "./Clinics.js?vue&type=script&lang=js&external"
export * from "./Clinics.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports